var _path, _path2, _path3, _path4, _rect, _rect2, _rect3, _rect4, _path5, _path6, _polygon, _path7, _path8, _path9, _path10, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _path11, _path12, _path13, _circle10, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInicio(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    width: 989.07679,
    height: 690.29009,
    viewBox: "0 0 989.07679 690.29009",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "online_art") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M868.46161,110.69V648.94269A379.61081,379.61081,0,0,0,729.11124,488.20038c-.64421-.41913-1.29623-.83831-1.94821-1.2419a376.11865,376.11865,0,0,0-202.556-58.80456H124.0903V110.69Z",
    transform: "translate(-105.46161 -104.85495)",
    fill: "#3f3d56"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M849.83292,699.82228V670.675c-59.66528-130.28129-191.1877-220.78763-343.85415-220.78763H105.46161V699.82228Z",
    transform: "translate(-105.46161 -104.85495)",
    fill: "#c1121f"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M191.45508,170.6499H169.354V148.54883h22.10108Zm-18.55469-3.5459h15.0083V152.09521h-15.0083Z",
    transform: "translate(-105.46161 -104.85495)",
    fill: "#f2f2f2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M647.634,636.17427H143.88328V539.14985H647.634Zm-502.19837-1.5524h500.646V540.70224h-500.646Z",
    transform: "translate(-105.46161 -104.85495)",
    fill: "#f2f2f2"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 54.72177,
    y: 472.71656,
    width: 40.36216,
    height: 40.36216,
    opacity: 0.1
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 171.92726,
    y: 452.53549,
    width: 331.4354,
    height: 10.09054,
    fill: "#f2f2f2"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 171.92726,
    y: 478.14993,
    width: 331.4354,
    height: 10.09054,
    fill: "#f2f2f2"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 171.92726,
    y: 503.76438,
    width: 331.4354,
    height: 10.09054,
    fill: "#f2f2f2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M221.50281,618.70987H159.40718V556.61424h62.09563Zm-60.54324-1.55239h58.99085V558.16664H160.95957Z",
    transform: "translate(-105.46161 -104.85495)",
    fill: "#f2f2f2"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M714.38684,621.03846a33.3764,33.3764,0,1,1,33.3764-33.3764A33.41452,33.41452,0,0,1,714.38684,621.03846Zm0-65.20041a31.824,31.824,0,1,0,31.824,31.824A31.8601,31.8601,0,0,0,714.38684,555.838Z",
    transform: "translate(-105.46161 -104.85495)",
    fill: "#f2f2f2"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "630.431 463.951 629.334 462.853 608.925 483.262 588.517 462.853 587.419 463.951 607.828 484.359 590.136 502.051 591.233 503.149 608.925 485.457 626.617 503.149 627.715 502.051 610.023 484.359 630.431 463.951",
    fill: "#f2f2f2"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M705.76332,124.70812,234.34106,204.47l37.84729,223.684h1.56793L236.12635,205.73516l468.364-79.234,59.91451,354.15465-37.24183,6.3027c.652.40359,1.304.82277,1.94821,1.2419l37.08663-6.27167Z",
    transform: "translate(-105.46161 -104.85495)",
    fill: "none",
    stroke: "#f2f2f2",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M492.783,334.34082c15.596,46.937,10.11866,91.00795,10.11866,91.00795s-30.76339-32.029-46.35937-78.96609-10.11865-91.00794-10.11865-91.00794S477.187,287.40379,492.783,334.34082Z",
    transform: "translate(-105.46161 -104.85495)",
    fill: "#c1121f"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M513.02027,334.34082c-15.596,46.937-10.11866,91.00795-10.11866,91.00795s30.76339-32.029,46.35937-78.96609,10.11866-91.00794,10.11866-91.00794S528.61625,287.40379,513.02027,334.34082Z",
    transform: "translate(-105.46161 -104.85495)",
    fill: "#c1121f"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M519.30175,334.84838c1.04539,49.44924-17.19735,89.93934-17.19735,89.93934s-19.93767-39.68294-20.98307-89.13217,17.19735-89.93934,17.19735-89.93934S518.25635,285.39915,519.30175,334.84838Z",
    transform: "translate(-105.46161 -104.85495)",
    fill: "#f2f2f2"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 394.74993,
    cy: 186.29147,
    r: 4.84085,
    fill: "#c1121f"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 385.33716,
    cy: 225.01829,
    r: 2.68936,
    fill: "#c1121f"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 352.52695,
    cy: 198.3936,
    r: 2.68936,
    fill: "#3f3d56"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 447.46143,
    cy: 172.30679,
    r: 2.68936,
    fill: "#3f3d56"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 366.51163,
    cy: 223.6736,
    r: 2.68936,
    fill: "#3f3d56"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 422.98824,
    cy: 208.0753,
    r: 2.68936,
    fill: "#3f3d56"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 368.12525,
    cy: 263.20723,
    r: 2.68936,
    fill: "#3f3d56"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 425.6776,
    cy: 247.87786,
    r: 2.68936,
    fill: "#3f3d56"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 399.59078,
    cy: 250.56723,
    r: 2.68936,
    fill: "#c1121f"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M1072.96161,706.25616s3,30,8,40c0,0-30,7-31,1s1-29,1-29Z",
    transform: "translate(-105.46161 -104.85495)",
    fill: "#a0616a"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M922.96161,721.25616s3,30,8,40c0,0-30,7-31,1s2-38,2-38Z",
    transform: "translate(-105.46161 -104.85495)",
    fill: "#a0616a"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M1052.96161,302.25616s21,70,8,83-44,57-44,57l-10-17s35-49,31-60-14-41-14-41S1040.96161,298.25616,1052.96161,302.25616Z",
    transform: "translate(-105.46161 -104.85495)",
    fill: "#a0616a"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 849.5,
    cy: 72.4012,
    r: 40,
    fill: "#a0616a"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M990.96161,182.25616s16,43,25,47,25,23,25,23,2,50-9,50-72-71-72-71,3-14-3-22S990.96161,182.25616,990.96161,182.25616Z",
    transform: "translate(-105.46161 -104.85495)",
    fill: "#a0616a"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M1005.96161,379.25616v12s18,31,19,87l9,100s47,76,40,120l1,17-24,8-8-14s-8-1-15-23l-43-97-26-79-16,103s7,95-11,98v15l-33,1v-14s-11,4-10-13,0-91,0-91l-6-127s-13.28809-59.49269-6.144-71.24635l39.144-65.75365Z",
    transform: "translate(-105.46161 -104.85495)",
    fill: "#2f2e41"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M1074.96161,744.25616s10-4,12,1,16,32,0,34-26,0-26,0-13-2-18-1-25-2-23-17,15-13,15-13,13-8,13-11,5,5,5,5S1056.96161,749.25616,1074.96161,744.25616Z",
    transform: "translate(-105.46161 -104.85495)",
    fill: "#2f2e41"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M924.96161,759.25616s10-4,12,1,16,32,0,34-26,0-26,0-13-2-18-1-25-2-23-17,15-13,15-13,13-8,13-11,5,5,5,5S906.96161,764.25616,924.96161,759.25616Z",
    transform: "translate(-105.46161 -104.85495)",
    fill: "#2f2e41"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M1020.96161,283.25616s34-7.7707,0-50.88535c0,0,27,7.88535,30,28.88535s4,47,4,47-17-5-26,18-22,35-18,59l-100-37s14-29,7-42,2-37,2-37,27-65,52-39S994.96161,277.25616,1020.96161,283.25616Z",
    transform: "translate(-105.46161 -104.85495)",
    fill: "#d0cde1"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M961.96161,279.25616s-4,66-15,78-55,62-55,62l-2,12-10,7s-10-24,1-34l38-68,9-64Z",
    transform: "translate(-105.46161 -104.85495)",
    fill: "#a0616a"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M930.96161,227.25616s23.31569-13.47455,29.65784-1.23728,3.34216,61.23728,3.34216,61.23728l-42-5S924.96161,228.25616,930.96161,227.25616Z",
    transform: "translate(-105.46161 -104.85495)",
    fill: "#d0cde1"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M909.10162,174.83611c-7.39-8.86-1.24-8.87-1.24-8.87.50989,3.18005,3.78992,7.13,7.11,10.42a83.94307,83.94307,0,0,0,7.46,6.5l-.7-2.43,6.51,4.28c2.1499,19.63,13.24,16.87,13.24,16.87-9.14-5.73-6.61011-15.26-5.34009-20.03,1.26-4.77,9.82007-3.76,10.32007,10.18s9.96,17.42,9.96,17.42l1.82007,7.94,1.59,6.92,4.33-7.84,2.03-3.68c13.6001,1.36,15.18994-11.42,15.18994-11.42a69.9832,69.9832,0,0,0,8.86011-4.99c21.25-14.26,14.11-30.64,8.99-38.16a32.04387,32.04387,0,0,0-3.33008-4.18c.3.06.6001.12.89014.17,40.76989,7.63,20.09985-15.91,20.09985-15.91l10.23,4.97,19.18018,2.39-15.49012-14.01c11.1-.6,22.23011,16.71,22.57,17.24-6.88989-20.89-20.36987-18.76-20.36987-18.76l4.06994-1.17-7.1-3.24,8.25,1.13995s-2.33008-1.97-5.93994-5.33c-3.61011-3.36-20.69007-4.59-20.69007-4.59,17.41-6.78,34.52991,6.77,34.52991,6.77-9.40991-21.33-32.53992-13.76-44-8.33l-5.59985.65c.11987-.41.27-2.09.17993-8-.14-9.4-11.26,6.98-11.81006,7.79,0-.12-.58-.76-8.15991-3.78-8.84009-3.53-5.07007,15.86-4.96,16.38v.00995s.08984.13-.65015.03c-1.38989-.18-5.69995-1.18-18.93994-5.38-11.43994-3.63-18.53.12-22.55005,4.09a57.55814,57.55814,0,0,1-18.46,12.56c-2.23.92-4.23,1.68-5.53,2.06-4.86987,1.4-7.41992,4.78-12.15991,15.83C888.8316,168.24615,908.5517,174.66613,909.10162,174.83611Z",
    transform: "translate(-105.46161 -104.85495)",
    fill: "#2f2e41"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M971.13161,128.18616c4.69,6.68,18.25,25.15,28.1,29.76a32.0455,32.0455,0,0,0-3.33-4.18c.3.06.6.12.89.17l-25.01-25.77v-.02Z",
    transform: "translate(-105.46161 -104.85495)",
    fill: "#d0cde1"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInicio);
export default __webpack_public_path__ + "static/media/inicio.8ecc63c94c046e891e77fd434eed3ba8.svg";
export { ForwardRef as ReactComponent };